import { makeRoute } from '~/utils/route';

export default makeRoute({
	path:        '/quick-import',
	title:       'menu.quickimport',
	// @ts-ignore
	redirectTo:  () => {
		window.location.href = '/front5/quick-import';
	},
});
